import { FC, useMemo } from 'react';
import { Project } from '@brg/api';
import { MEDIA } from '@brg/ui';
import styled from 'styled-components';
import { LayoutConst } from 'core';
import { parseFtblPlayerInfo } from './parseFtblPlayerInfo';
import { getFtblPlayerRoleBackgroundColor } from './ftblPlayerRole';

const PlayerFTBLRoot = styled.div<{ $backgroundColor: string }>`
  width: 100%;
  height: 100%;
  min-height: 100%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const PlayerInfoBlock = styled.div`
  margin-top: 80px;
  width: 524px;
  display: flex;
  padding: 20px 40px;
  align-items: center;
  background: #4653B6;
  box-sizing: border-box;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: 56px;
    width: 400px;
    min-height: 108px;
    padding: 16px 32px;
    gap: 7.66px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-top: 48px;
    width: 324px;
    min-height: 84px;
    padding: 12px 24px;
    gap: 6.17px;
  }

  @media ${MEDIA.MOBILE} {
    margin-top: 32px;
    width: 284px;
    min-height: 66px;
    padding: 8px 16px;
    gap: 5.32px;
  }
`;

const PlayerName = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
  color: #fff;
  font-family: "Alumni Sans", sans-serif;
  font-size: 100px;
  font-style: normal;
  font-weight: 700;
  line-height: 80px;
  text-transform: uppercase;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 325px;
    font-size: 76px;
    line-height: 76px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    max-width: 254px;
    font-size: 60px;
    line-height: 60px;
  }

  @media ${MEDIA.MOBILE} {
    max-width: 204px;
    font-size: 50px;
    line-height: 50px;
  }
`;

const PlayerRating = styled.span`
  display: block;
  margin-top: auto;
  margin-left: 40px;
  margin-bottom: 40px;
  max-width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #4653B6;
  font-family: "Alumni Sans", sans-serif;
  font-size: 130px;
  font-style: normal;
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-left: 32px;
    margin-bottom: 32px;
    max-width: calc(100% - 32px);
    font-size: 100px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-left: 24px;
    margin-bottom: 24px;
    max-width: calc(100% - 24px);
    font-size: 85px;
  }

  @media ${MEDIA.MOBILE} {
    margin-left: 16px;
    margin-bottom: 16px;
    max-width: calc(100% - 16px);
    font-size: 75px;
  }
`;

type PlayerFTBLProps = {
    project: Project;
};

export const PlayerFTBL: FC<PlayerFTBLProps> = ({ project }) => {
    const playerInfo = useMemo(
        () => parseFtblPlayerInfo(project?.additionalInfo?.PlayerInfo),
        [project],
    );

    const roleBackgroundColor = useMemo(
        () => getFtblPlayerRoleBackgroundColor(playerInfo?.Role),
        [playerInfo?.Role],
    );

    return (
        <PlayerFTBLRoot $backgroundColor={roleBackgroundColor}>
            <PlayerInfoBlock>
                <PlayerName>{playerInfo?.FullName ?? ''}</PlayerName>
            </PlayerInfoBlock>
            <PlayerRating>
                {playerInfo?.Rating != null ? playerInfo.Rating : ''}
            </PlayerRating>
        </PlayerFTBLRoot>
    );
};
import { FC, useMemo } from 'react';
import { Project } from '@brg/api';
import { MEDIA } from '@brg/ui';
import styled from 'styled-components';
import { LayoutConst } from 'core';
import { parseFtblPlayerInfo } from './parseFtblPlayerInfo';
import { getFtblPlayerRoleBackgroundColor } from './ftblPlayerRole';

const PlayerFTBLRoot = styled.div<{ $backgroundColor: string }>`
  width: 100%;
  height: 100%;
  min-height: 100%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const PlayerInfoBlock = styled.div`
  margin-top: 80px;
  width: 524px;
  display: flex;
  padding: 20px 40px;
  align-items: center;
  background: #4653B6;
  box-sizing: border-box;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: 56px;
    width: 400px;
    min-height: 108px;
    padding: 16px 32px;
    gap: 7.66px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-top: 48px;
    width: 324px;
    min-height: 84px;
    padding: 12px 24px;
    gap: 6.17px;
  }

  @media ${MEDIA.MOBILE} {
    margin-top: 32px;
    width: 284px;
    min-height: 66px;
    padding: 8px 16px;
    gap: 5.32px;
  }
`;

const PlayerName = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
  color: #fff;
  font-family: "Alumni Sans", sans-serif;
  font-size: 100px;
  font-style: normal;
  font-weight: 700;
  line-height: 80px;
  text-transform: uppercase;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 325px;
    font-size: 76px;
    line-height: 76px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    max-width: 254px;
    font-size: 60px;
    line-height: 60px;
  }

  @media ${MEDIA.MOBILE} {
    max-width: 204px;
    font-size: 50px;
    line-height: 50px;
  }
`;

const PlayerRating = styled.span`
  display: block;
  margin-top: auto;
  margin-left: 40px;
  margin-bottom: 40px;
  max-width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #4653B6;
  font-family: "Alumni Sans", sans-serif;
  font-size: 130px;
  font-style: normal;
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-left: 32px;
    margin-bottom: 32px;
    max-width: calc(100% - 32px);
    font-size: 100px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-left: 24px;
    margin-bottom: 24px;
    max-width: calc(100% - 24px);
    font-size: 85px;
  }

  @media ${MEDIA.MOBILE} {
    margin-left: 16px;
    margin-bottom: 16px;
    max-width: calc(100% - 16px);
    font-size: 75px;
  }
`;

type PlayerFTBLProps = {
    project: Project;
};

export const PlayerFTBL: FC<PlayerFTBLProps> = ({ project }) => {
    const playerInfo = useMemo(
        () => parseFtblPlayerInfo(project?.additionalInfo?.PlayerInfo),
        [project],
    );

    const roleBackgroundColor = useMemo(
        () => getFtblPlayerRoleBackgroundColor(playerInfo?.Role),
        [playerInfo?.Role],
    );

    return (
        <PlayerFTBLRoot $backgroundColor={roleBackgroundColor}>
            <PlayerInfoBlock>
                <PlayerName>{playerInfo?.FullName ?? ''}</PlayerName>
            </PlayerInfoBlock>
            <PlayerRating>
                {playerInfo?.Rating != null ? playerInfo.Rating : ''}
            </PlayerRating>
        </PlayerFTBLRoot>
    );
};
